import React from 'react';
import PropTypes from 'prop-types';
import ReportGmailerrorred from '@mui/icons-material/ReportGmailerrorred';

import { Typo } from 'uikit/content';

import styles from '../styles/formFieldError.module.scss';

const FormFieldError = ({ hasError = false, isDirty = false, isHidden = false, error = '' }) => {
  if (!hasError || !isDirty || isHidden) return null;

  return (
    <div className={styles.element}>
      <ReportGmailerrorred className={styles.icon} sx={{ height: 18, width: 18 }} />
      <Typo className={styles.text} variant="s01">
        {error}
      </Typo>
    </div>
  );
};

FormFieldError.propTypes = {
  hasError: PropTypes.bool,
  isDirty: PropTypes.bool,
  isHidden: PropTypes.bool,
  error: PropTypes.string,
};

export { FormFieldError as FormFieldErrorStorybook };
export default React.memo(FormFieldError);
